import { Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetWhPerformanceStatistics } from 'api/statistic/use-get-wh-performance-statistics';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { useWhPerformanceFiltersStore } from 'shared/stores/use-wh-performance-filters';
import { BubbleChart } from 'components/insights/bubble-chart';
import { WhPerformanceFilters } from 'components/statistics/wh-performance-filters';
import { WhPerformanceList } from 'components/statistics/wh-performance-list';

const WhPerformancePageComponent = () => {
  const { filters } = useWhPerformanceFiltersStore();
  const { data: statisticsData, isFetching } = useGetWhPerformanceStatistics({ filters });

  const header = <PageHeader title={<WhPerformanceFilters />} />;

  const chartData =
    statisticsData?.series.map((item) => ({
      x: item.ldm,
      y: item.load,
      z: item.ldm,
      name: item.name,
    })) ?? [];

  return (
    <DefaultPageLayout header={header}>
      <Skeleton loading={isFetching}>
        {statisticsData && (
          <>
            <BubbleChart
              title='Warehouse Performance'
              data={chartData}
              xAxisTitle='LDM'
              yAxisTitle='Load (%)'
              seriesName='Warehouses'
            />
            <WhPerformanceList data={statisticsData.series} isLoading={isFetching} />
          </>
        )}
      </Skeleton>
    </DefaultPageLayout>
  );
};

export const WhPerformancePage = withRoleGuard(WhPerformancePageComponent, [UserRole.admin]);
